import template from './firmwareUpgradeModal.html';

class FirmwareUpgradeModalController {
    /* @ngInject */
    constructor() {
        this.$close = this.config.close;
        this.$dismiss = this.config.dismiss;
    }

    close() {
        this.$close();
    }
}

export default {
template: template,
    bindings: {
    config: '='
    },
controller: FirmwareUpgradeModalController
};